import {
  GET_ACTIVITY_TYPE_LIST,
  GET_EXPORT_DATA_ACTIVITY,
  GET_EXPORT_DATA_OVERALL,
  GET_LIST_LIMIT_FTE,
  GET_STRUCTURE_EMPLOYEE,
  GET_VALIDATION_WLA,
  GET_WLA_CHART_PROCESS,
  GET_WLA_DASHBOARD_DEPARTEMENT,
  GET_WLA_DASHBOARD_DIVISION,
  GET_WLA_DASHBOARD_EMPLOYEE,
  GET_WLA_DASHBOARD_EMPLOYEE_REGION,
  GET_WLA_DASHBOARD_JOBLVL,
  GET_WLA_DETAIL,
  GET_WLA_LIST,
  GET_WLA_LIST_TEMPLATE,
  GET_WLA_OC_BOARD,
  GET_WLA_OC_DEPARTEMENT,
  GET_WLA_OC_EMPLOYEE,
  GET_WLA_OC_LIST,
  GET_WLA_OC_ORG,
  GET_WLA_PROGRESS_SUMMARY,
  GET_WORKER_TYPE_LIST,
  GET_LIST_CUSTOM_CATEGORY,
  GET_WLA_DETAIL_STRUCTURE,
  GET_WLA_BAR_CHART,
  GET_WLA_DETAIL_ORG,
  GET_WLA_ORG_PROCESS,
  GET_WLA_LIST_PROCESS,
} from 'redux/actions/wla';

const initialState = {
  validation: false,
  render_activity_name: [],
  worker_type: [],
  worker_type_list: [],
  activity_type_list: [],
  list_status: [],
  list_fte: [],
  list_template: [],
  detail_status: [],
  dataOverall: [],
  dataActivity: [],
  structureEmployee: [],
  process_chart: [],
  dashboard: {
    employee: {},
    job_level: [],
    division: [],
    departement: [],
  },
  progress_summary: [],
  progress_summary_status: [],
  other_category_board: [],
  other_category_list: [],
  list_custom_category: [],
  wla_detail_structure: {},
  bar_chart: {},
  detailWlaResult: {},
  detailWlaProcess: {},
  listProcessWla: {},
};
// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_VALIDATION_WLA: {
      return {
        ...state,
        validation: payload,
        render_activity_name: payload.activty,
        worker_type: [payload.worker_type],
      };
    }
    case GET_WORKER_TYPE_LIST: {
      if (payload.id !== undefined) {
        const data = state.worker_type_list;
        data[payload.id] = payload.data;

        return {
          ...state,
          worker_type_list: data,
        };
      }
      return {
        ...state,
        worker_type_list: payload,
      };
    }
    case GET_WLA_DASHBOARD_EMPLOYEE: {
      if (payload?.action === 'update') {
        state.dashboard.employee = {
          ...state.dashboard.employee,
          status_wla:
            state.dashboard.employee.status_wla === 'open' ? 'closed' : 'open',
        };
      } else {
        state.dashboard.employee = payload[0];
      }
      return state;
    }
    case GET_WLA_DASHBOARD_EMPLOYEE_REGION: {
      if (payload?.action === 'update') {
        state.dashboard.employee = {
          ...state.dashboard.employee,
          status_wla:
            state.dashboard.employee.status_wla === 'open' ? 'closed' : 'open',
        };
      } else {
        state.dashboard.employee = payload;
      }
      return state;
    }
    case GET_WLA_DASHBOARD_JOBLVL: {
      state.dashboard.departement = payload;
      return state;
    }
    case GET_WLA_DASHBOARD_DIVISION: {
      state.dashboard.division = payload;
      return state;
    }
    case GET_WLA_DASHBOARD_DEPARTEMENT: {
      state.dashboard.jobtitle = payload[0];
      return state;
    }
    case GET_ACTIVITY_TYPE_LIST: {
      if (payload?.insert_data) {
        state.activity_type_list.push(payload.data);
        return state;
      }
      if (payload?.update_data) {
        state.activity_type_list[payload.id] = payload.data;
        return state;
      }

      return {
        ...state,
        activity_type_list: payload,
      };
    }
    case GET_WLA_LIST: {
      if (payload.action === 'update') {
        const newListStatus = [...state.list_status];
        newListStatus[payload.index].status = payload.status;
        return {
          ...state,
          list_status: newListStatus,
        };
        // const datas = (state.list_status[payload.index].status =
        //   payload.status);
        // return {
        //   ...state,
        //   list_status: [...state.list_status, datas]
        // };
      }
      return {
        ...state,
        list_status: payload,
      };
    }
    case GET_WLA_DETAIL: {
      return {
        ...state,
        detail_status: payload[0],
      };
    }
    case GET_STRUCTURE_EMPLOYEE: {
      return {
        ...state,
        structureEmployee: payload,
      };
    }
    case GET_EXPORT_DATA_OVERALL: {
      return {
        ...state,
        dataOverall: payload,
      };
    }
    case GET_EXPORT_DATA_ACTIVITY: {
      return {
        ...state,
        dataActivity: payload,
      };
    }
    case GET_LIST_LIMIT_FTE: {
      if (payload?.insert_data) {
        state.list_fte.push(payload.data);
        return state;
      }
      if (payload?.update_data) {
        state.list_fte[payload.id] = payload.data;
        return state;
      }
      return {
        ...state,
        list_fte: payload,
      };
    }
    case GET_WLA_OC_BOARD: {
      return {
        ...state,
        other_category_board: payload,
      };
    }
    case GET_WLA_OC_DEPARTEMENT: {
      return {
        ...state,
        other_category_departement: payload,
      };
    }
    case GET_WLA_OC_ORG: {
      return {
        ...state,
        other_category_org: payload,
      };
    }
    case GET_WLA_LIST_TEMPLATE: {
      return {
        ...state,
        list_template: payload,
      };
    }
    case GET_WLA_OC_EMPLOYEE: {
      return {
        ...state,
        other_category_employee: payload,
      };
    }
    case GET_WLA_OC_LIST: {
      if (payload?.insert_data) {
        const temp = [...state.other_category_list];
        temp.splice(0, 0, payload.data);
        return {
          ...state,
          other_category_list: temp,
        };
      }
      if (payload?.update_data) {
        const temp = [...state.other_category_list];
        temp[payload.id] = payload.data;
        return {
          ...state,
          other_category_list: temp,
        };
      }
      return {
        ...state,
        other_category_list: payload.data,
      };
    }
    case GET_WLA_PROGRESS_SUMMARY:
      return {
        ...state,
        ...payload,
      };
      break;
    case GET_WLA_CHART_PROCESS:
      return {
        ...state,
        process_chart: payload,
      };
      break;
    case GET_LIST_CUSTOM_CATEGORY:
      return {
        ...state,
        list_custom_category: payload,
      };
      break;
    case GET_WLA_DETAIL_STRUCTURE:
      return {
        ...state,
        wla_detail_structure: payload,
      };
    case GET_WLA_BAR_CHART:
      return {
        ...state,
        bar_chart: payload,
      };
    case GET_WLA_DETAIL_ORG:
      return {
        ...state,
        detailWlaResult: payload,
      };
    case GET_WLA_ORG_PROCESS:
      return {
        ...state,
        detailWlaProcess: payload,
      };
    case GET_WLA_LIST_PROCESS:
      return {
        ...state,
        listProcessWla: payload,
      };

    default:
      return state;
  }
};
